// A WAM v2 instrument plugin hosted as a track's sound source. Loads the module
// from a URL, connects its audioNode into the channel, and routes MIDI to it via
// WAM `scheduleEvents` (wam-midi). Needs a real AudioContext + network (WAM host
// runtime + module), so offline export skips it (like WAM effects).
import { Instrument } from "./instrument";
import { ensureHost } from "./wam-host";

export class WamInstrument implements Instrument {
  output: GainNode;
  ready: Promise<void>;
  name = "WAM Instrument";
  instance: any = null;
  private node: any = null;
  private held = new Set<number>();

  constructor(private ctx: BaseAudioContext, private url: string) {
    this.output = ctx.createGain();
    this.ready = this.load();
  }

  private async load() {
    try {
      const groupId = await ensureHost(this.ctx as AudioContext);
      const mod: any = await import(/* @vite-ignore */ this.url);
      const WAM = mod.default;
      if (!WAM?.createInstance) throw new Error("Not a valid WAM v2 module.");
      const instance = await WAM.createInstance(groupId, this.ctx);
      this.instance = instance;
      this.node = instance.audioNode;
      this.name = instance.descriptor?.name || "WAM Instrument";
      this.node.connect(this.output);
    } catch (e) { console.warn("WAM instrument load failed", e); }
  }

  private send(bytes: number[], time: number) {
    try { this.node?.scheduleEvents({ type: "wam-midi", time, data: { bytes } }); } catch {}
  }
  noteOn(midi: number, vel = 0.8) { if (!this.node) return; this.held.add(midi); this.send([0x90, midi, Math.max(1, Math.round(vel * 127))], this.ctx.currentTime); }
  noteOff(midi: number) { if (!this.node) return; this.held.delete(midi); this.send([0x80, midi, 0], this.ctx.currentTime); }
  scheduleNote(midi: number, vel: number, start: number, dur: number) {
    if (!this.node) return;
    this.send([0x90, midi, Math.max(1, Math.round(vel * 127))], start);
    this.send([0x80, midi, 0], start + dur);
  }
  allNotesOff() {
    if (!this.node) return;
    for (const m of this.held) this.send([0x80, m, 0], this.ctx.currentTime);
    this.held.clear();
    this.send([0xb0, 123, 0], this.ctx.currentTime); // all-notes-off CC
  }
  dispose() { this.allNotesOff(); try { this.instance?.destroy?.(); } catch {} try { this.output.disconnect(); } catch {} }
}
